<template lang="html">
<div class="pgInner adsMessage" :style="'height:' + pageH + 'px;'">

      <div class="tabNavs" ref="tabNavs">
           <span>认证审核</span>
           <div class="btns">
                <el-button  @click="goFrash" size="mini">刷新</el-button>
           </div>
      </div>

      <div class="seekLine">
          <div class="seekGp">
              <el-input  @input="reInxList" placeholder="请输入关键字" v-model="listParams.keyword">
                    <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div>

          <div class="inpGp">
            <el-select v-model="listParams.status" clearable placeholder="状态" @change="stateChange">
              <el-option
                v-for="item in options"
                :key="item.key"
                :label="item.name"
                :value="item.key">
              </el-option>
            </el-select>
          </div>

      </div>

      <div class="pgbody">

          <el-table
             :data="listData"
             header-row-class-name="tableHead"
             v-loading="loading"
             style="width: 100%">

             <el-table-column
               prop="companyName"
               label="企业名称">
             </el-table-column>

             <el-table-column
               prop="identityType"
               width="120"
               align="center"
               label="身份类型">
             </el-table-column>

             <el-table-column
               label="状态"
               align="center"
               width="120">

               <template slot-scope="scope">
                     {{ scope.row.status | datFormate(1) }}
               </template>

             </el-table-column>

             <el-table-column
               prop="reviewer"
               align="center"
               width="120"
               label="审核人">
             </el-table-column>

             <el-table-column
               align="center"
               width="120"
               label="审核日期">

               <template slot-scope="scope">
                 {{ scope.row.reviewTime.substr(0,11) }}
               </template>

             </el-table-column>

             <el-table-column
               prop="reviewApplicationTime"
               align="center"
               width="180"
               label="申请时间">

             </el-table-column>
             <el-table-column
               label="操作"
               align="center"
               width="210">
               <template slot-scope="scope">

                  <div v-if="scope.row.status==1 || scope.row.status==5" class="ibtn">
                    <span @click="goEdit(scope.row)">审核</span>
                  </div>

               </template>

             </el-table-column>
          </el-table>

          <div class="table-footer">

              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="handleCurrentChange"
                :current-page="listParams.no"
                :page-count="allPages"
                layout="total, prev, pager, next, jumper">
              </el-pagination>

          </div>

      </div>

</div>
</template>

<script>
import { getEnterpriseList } from "@/api/attes/attestation";
export default {
    computed:{
      lineStr:function(){
          var str = "left:" + this.navX + "px;";
          return str;
      }
    },
    filters:{
        datFormate:function(e,type){
            if(type == 1){    // 状态
                var transMap = {
                    1:'未认证',
                    2:'已认证',
                    3:'已解散',
                    4:'审核失败',
                    5:'未认证'
                };
                return transMap[e];
            }
        }
    },
    data(){
        return{
            pageH:'',

            options:[],
            listData:[],
            selectArr:[],

            loading:false,

            listParams:{
              keyword:'',
              status:'',
              statusList:[1,2,4],
              sort:2,
              no:1,
              size:12
            },

            allPages:0,
            allEls:0,

            options:[
               { key:1,name:'待审核' },
               { key:2,name:'已认证' },
               { key:4,name:'未通过' }
            ],

            typeId:''  // 活动通告类型 id
        }
    },
    methods:{
        getList:function(){
            this.loading = true;
            getEnterpriseList(this.listParams).then(res => {
                this.listData = res.enterpriseList;
                this.loading = false;
                this.allPages = res.totalPages;
                this.allEls = res.totalElements;
            })
        },
        stateChange:function(e){
            if(e){
               this.listParams.statusList = [e];
            }else{
               this.listParams.statusList = [1,2,4];
            };
            this.reInxList();
        },
        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 50;
        },

        goRemove:function(e){     // 批量删除
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                msgRemove({ids:this.selectArr}).then(res => {
                    vues.reInxList();
                    vues.selectArr = [];
                })
            }else{
                this.$message.error('请选择删除项！');
            }
        },

        changeState:function(status,e){
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                statusSet({ids:this.selectArr,status:status}).then(res => {
                    vues.reInxList();
                    vues.selectArr = [];
                })
            }else{
                this.$message.error('请选择操作项！');
            }
        },

        goEdit:function(e){   // 编辑
            this.$router.push({
                path:'attes_edit',
                query:{
                   id:e.id
                }
            });
        },

        tabSelect:function(e){
            var arrs = [];
            e.forEach(item => {
                arrs.push(item.id);
            })
            this.selectArr = arrs;
        },

        selectChange:function(e){    // 类型
            // this.reInxList();
        },

        handleCurrentChange:function(e){
            this.listParams.no = e;
            this.getList();
        },
        reInxList:function(){
            this.listParams.no = 1;
            this.getList();
        },
        goFrash:function(){
            this.$emit('go-frash');
        },
        prevSet:function(){

            // 底部定位
            this.pageFix();
            this.typeIdSet();


        },
    },
    created:function(){

        this.pageFix();
        this.getList();

    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.tabNavs{
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  background: white;
  position: relative;
  border-bottom: 1px solid #efefef;
  .btns{
    float: right;
    height: 60px;
    padding-right: 20px;
  }
}

.seekLine{
  padding: 20px;
  background: white;
  .seekGp{
     width: 420px;
     display: inline-block;
  }

  .inpGp{
    width: 150px;
    display: inline-block;
    margin-left: 12px;
  }
}

.pgbody{
  margin: 20px;
  .ibtn{
      display: inline-block;
      font-size: 14px;
      margin-right: 3px;
      span{
         cursor: pointer;
         color: #409EFF;
      }
      .dvLine{
         display: inline-block;
         height: 14px;
         width: 2px;
         vertical-align: middle;
         margin-top: -2px;
         margin-left: 3px;
         background: #EAEAEA;

      }
  }

  .ibtn:last-child .dvLine{
    display: none;
  }

  .table-footer{
    height: 50px;
    background: white;
    padding: 0 30px;
    text-align: right;

    .btns{
      float: left;
      line-height: 50px;
    }

    .paging{
      display: inline-block;
      margin-top: 9px;
    }
  }

}

</style>

<style lang="scss">
.adsMessage .tableHead th{
   background: #efefef;
   font-weight: normal;
   color: #666666;
}

.adsMessage .seekLine{

  .el-input__inner{
    border-radius: 0px !important;
  }

  .el-input-group__append{
    border-radius: 0px !important;
  }

}

</style>



// WEBPACK FOOTER //
// attestation.vue?314c063b